export default __webpack_public_path__ + "static/media/num-4.173d6e94.svg";